const signInEnum = Object.freeze({
  BASELINE: 'Baseline',
  APPLICATION_INFO: '',
});

export default signInEnum;
